// extracted by mini-css-extract-plugin
module.exports = {"root":"Empty__root--2wu6b Container__container--2Emzb","image":"Empty__image--kwRF5","text":"Empty__text--1f2YY"};